import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const heroSlides = [
    {
      image: 'https://public.readdy.ai/ai/img_res/52fa546b7a39cd83b4cd1c6bfc7ac5c6.jpg',
      title: 'Professional Petroleum Storage Solutions',
      subtitle: 'Secure tank farm storage with 100,000 m³ capacity and advanced monitoring systems'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Real%20oil%20tanker%20vessel%20at%20industrial%20port%20terminal%20loading%20petroleum%20products%2C%20authentic%20maritime%20shipping%20photography%20showing%20large%20commercial%20tanker%20ship%20at%20working%20port%20facility%2C%20professional%20documentary%20photograph%20of%20petroleum%20vessel%20operations%20at%20harbor%20with%20storage%20tanks%20visible%2C%20realistic%20commercial%20maritime%20logistics%20showing%20actual%20vessel%20loading%20operations%20with%20blue%20ocean%20and%20industrial%20port%20infrastructure%2C%20high%20quality%20photojournalism%20style%20image&width=1920&height=600&seq=hero-slide-002&orientation=landscape',
      title: 'Comprehensive Shipping Services',
      subtitle: 'Fleet of 31 vessels for maritime, railway, and motor transport solutions'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Real%20petroleum%20laboratory%20scientist%20in%20white%20coat%20and%20safety%20goggles%20analyzing%20oil%20samples%20with%20professional%20testing%20equipment%2C%20authentic%20industrial%20laboratory%20photography%20showing%20actual%20quality%20control%20testing%20procedures%20for%20petroleum%20products%2C%20documentary%20style%20photograph%20of%20working%20lab%20environment%20with%20real%20testing%20instruments%20and%20professional%20safety%20protocols%2C%20high%20quality%20photojournalism%20showing%20genuine%20petroleum%20analysis%20facility%20with%20natural%20lighting%20and%20real%20equipment&width=1920&height=600&seq=hero-slide-003&orientation=landscape',
      title: 'Advanced Laboratory Analysis',
      subtitle: 'Precise quality control and continuous monitoring of petroleum products'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const services = [
    {
      icon: 'ri-database-2-line',
      title: 'Storage of Petroleum Products',
      description: 'Secure and specialized storage solutions with dedicated fuel storage tanks and independent pipelines to eliminate cross-contamination.',
      link: '/storage',
      image: 'https://readdy.ai/api/search-image?query=Real%20industrial%20petroleum%20storage%20tanks%20with%20white%20cylindrical%20design%20at%20working%20tank%20farm%20facility%2C%20authentic%20documentary%20photography%20of%20actual%20oil%20storage%20terminal%20showing%20modern%20infrastructure%20and%20operational%20safety%20systems%2C%20professional%20photojournalism%20of%20functioning%20petroleum%20terminal%20with%20multiple%20storage%20tanks%20under%20natural%20daylight%2C%20realistic%20commercial%20photograph%20showing%20genuine%20industrial%20operations&width=400&height=300&seq=service-storage-001&orientation=landscape',
      showLogo: false
    },
    {
      icon: 'ri-flask-line',
      title: 'Laboratory Analysis',
      description: 'Precise and timely analysis of petroleum products with continuous monitoring and quality assessments.',
      link: '/laboratory',
      image: 'https://readdy.ai/api/search-image?query=Authentic%20petroleum%20testing%20laboratory%20with%20real%20scientific%20equipment%20and%20actual%20oil%20sample%20analysis%2C%20professional%20documentary%20photograph%20of%20lab%20technician%20conducting%20genuine%20quality%20control%20tests%20on%20petroleum%20products%2C%20realistic%20industrial%20laboratory%20environment%20showing%20real%20testing%20instruments%20and%20working%20safety%20protocols%2C%20photojournalism%20style%20image%20of%20actual%20laboratory%20operations&width=400&height=300&seq=service-lab-001&orientation=landscape',
      showLogo: false
    },
    {
      icon: 'ri-building-line',
      title: 'Tank Leasing',
      description: 'Flexible tank leasing options with 100,000 m³ total storage capacity and real-time monitoring systems.',
      link: '/tank-leasing',
      image: 'https://readdy.ai/api/search-image?query=Real%20large%20petroleum%20storage%20tank%20with%20actual%20monitoring%20systems%20and%20safety%20equipment%20at%20working%20facility%2C%20professional%20documentary%20photography%20of%20genuine%20industrial%20tank%20leasing%20operations%20showing%20real%20advanced%20technology%2C%20authentic%20commercial%20photograph%20of%20operational%20oil%20storage%20tank%20with%20real-time%20monitoring%20displays%20and%20professional%20infrastructure%2C%20realistic%20industrial%20photography&width=400&height=300&seq=service-lease-001&orientation=landscape',
      showLogo: false
    },
    {
      icon: 'ri-ship-line',
      title: 'Maritime Shipping',
      description: 'Controlled fleet of 31 vessels including self-propelled vessels, barges, and push tugs for maritime transport.',
      link: '/maritime',
      image: 'https://readdy.ai/api/search-image?query=Real%20oil%20tanker%20vessel%20at%20sea%20transporting%20petroleum%20products%2C%20authentic%20maritime%20shipping%20photography%20with%20actual%20commercial%20tanker%20ship%20on%20blue%20ocean%2C%20professional%20documentary%20photograph%20of%20genuine%20petroleum%20transport%20vessel%20showing%20real%20maritime%20operations%20and%20safety%20standards%2C%20realistic%20photojournalism%20of%20working%20tanker%20ship&width=400&height=300&seq=service-maritime-001&orientation=landscape',
      showLogo: false
    },
    {
      icon: 'ri-train-line',
      title: 'Railway Shipping',
      description: 'Professional railway transportation ensuring full compliance with U.S. and international regulations.',
      link: '/railway',
      image: 'https://readdy.ai/api/search-image?query=Real%20railway%20tank%20cars%20transporting%20petroleum%20products%20on%20actual%20industrial%20rail%20line%2C%20authentic%20documentary%20photography%20of%20genuine%20petroleum%20railway%20shipping%20with%20specialized%20tank%20wagons%2C%20professional%20photojournalism%20of%20actual%20rail%20transport%20of%20oil%20products%20showing%20real%20safety%20compliance%20and%20working%20logistics%20infrastructure%2C%20realistic%20commercial%20photograph&width=400&height=300&seq=service-railway-001&orientation=landscape',
      showLogo: false
    },
    {
      icon: 'ri-truck-line',
      title: 'Motor Transport',
      description: 'Road transportation services conducted in strict adherence to regulatory standards for safe delivery.',
      link: '/motor-transport',
      image: 'https://readdy.ai/api/search-image?query=Real%20professional%20petroleum%20tanker%20truck%20on%20highway%20transporting%20actual%20oil%20products%2C%20authentic%20commercial%20photograph%20of%20genuine%20fuel%20transport%20vehicle%20with%20safety%20equipment%2C%20documentary%20style%20photography%20of%20working%20motor%20transport%20showing%20real%20professional%20logistics%20and%20regulatory%20compliance%20for%20petroleum%20delivery%2C%20realistic%20photojournalism%20of%20actual%20tanker%20truck%20operations&width=400&height=300&seq=service-motor-001&orientation=landscape',
      showLogo: false
    },
  ];

  const stats = [
    { value: '100,000', label: 'Storage Capacity (m³)', icon: 'ri-database-2-line' },
    { value: '31', label: 'Vessel Fleet', icon: 'ri-ship-line' },
    { value: '6', label: 'Core Services', icon: 'ri-service-line' },
    { value: '24/7', label: 'Operations', icon: 'ri-time-line' },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section with Carousel */}
        <section className="relative min-h-[600px] overflow-hidden">
          {heroSlides.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
              style={{
                backgroundImage: `linear-gradient(rgba(0, 20, 60, 0.7), rgba(0, 20, 60, 0.7)), url('${slide.image}')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            >
              <div className="max-w-7xl mx-auto px-6 lg:px-12 h-[600px] flex items-center">
                <div className="max-w-3xl">
                  <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                    {slide.title}
                  </h1>
                  <p className="text-xl text-gray-200 mb-8 leading-relaxed">
                    {slide.subtitle}
                  </p>
                  <div className="flex flex-wrap gap-4">
                    <Link 
                      to="/services" 
                      className="px-8 py-4 bg-blue-900 text-white font-semibold rounded-lg hover:bg-blue-800 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      Explore Our Services
                    </Link>
                    <Link 
                      to="/contact" 
                      className="px-8 py-4 bg-white text-gray-900 font-semibold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      Contact Us
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
          
          {/* Slide Indicators */}
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-3 z-10">
            {heroSlides.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                  index === currentSlide ? 'bg-white w-8' : 'bg-white/50'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${stat.icon} text-3xl text-blue-900`}></i>
                  </div>
                  <div className="text-4xl font-bold text-gray-900 mb-2">{stat.value}</div>
                  <div className="text-gray-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Core Services</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Comprehensive petroleum logistics solutions tailored to your needs
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {services.map((service, index) => (
                <div key={index} className="bg-gray-50 rounded-xl p-8 hover:shadow-xl transition-all duration-300 hover:scale-105 border-2 border-transparent hover:border-teal-500">
                  <div className="relative mb-6">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="w-full h-48 object-cover rounded-lg"
                    />
                  </div>
                  <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg flex items-center justify-center mb-6">
                    <i className={`${service.icon} text-3xl text-white`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">{service.title}</h3>
                  <p className="text-gray-600 mb-6">{service.description}</p>
                  <Link 
                    to={service.link} 
                    className="text-teal-600 font-semibold hover:text-teal-700 inline-flex items-center cursor-pointer whitespace-nowrap"
                  >
                    Learn More <i className="ri-arrow-right-line ml-2"></i>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Choose Us Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-4xl font-bold text-gray-900 mb-6">Why Choose TONCENT?</h2>
                <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                  With decades of experience in petroleum logistics, we deliver reliable, safe, and efficient solutions tailored to your needs.
                </p>
                <div className="space-y-6">
                  <div className="flex gap-4">
                    <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-shield-check-line text-xl text-blue-900"></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 mb-2">Safety First</h3>
                      <p className="text-gray-600">Full compliance with international safety standards and regulations.</p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-line-chart-line text-xl text-blue-900"></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 mb-2">Advanced Technology</h3>
                      <p className="text-gray-600">Real-time monitoring systems and modern infrastructure.</p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-customer-service-2-line text-xl text-blue-900"></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 mb-2">24/7 Support</h3>
                      <p className="text-gray-600">Round-the-clock operations and customer service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=Real%20professional%20petroleum%20industry%20workers%20in%20actual%20safety%20gear%20and%20hard%20hats%20inspecting%20large%20white%20industrial%20storage%20tanks%20at%20working%20tank%20farm%20facility%2C%20authentic%20documentary%20photography%20showing%20genuine%20safety%20protocols%20and%20professional%20operations%20under%20natural%20daylight%2C%20realistic%20photojournalism%20of%20workers%20conducting%20actual%20quality%20inspection%20at%20clean%20organized%20petroleum%20terminal%2C%20high%20quality%20documentary%20photograph%20showing%20real%20industrial%20team%20and%20modern%20infrastructure&width=600&height=700&seq=why-choose-001&orientation=portrait"
                  alt="Professional petroleum operations"
                  className="rounded-2xl shadow-2xl w-full h-auto object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-r from-blue-900 via-blue-800 to-teal-900">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">Ready to Optimize Your Petroleum Logistics?</h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
              Contact us today to discuss how our comprehensive services can support your business
            </p>
            <Link 
              to="/contact" 
              className="inline-block px-8 py-4 bg-teal-500 text-white font-semibold rounded-lg hover:bg-teal-600 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Get in Touch
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}